import { Button, Col, Row } from 'antd';
import React, { useEffect, useState } from 'react';
// import { Link, useHistory } from 'react-router-dom'
// import CampignIntroComponent from '../../components/Brand/CampignIntroComponent'
// import BrandTopSubHeaderComponent from '../../components/Brand/Common/BrandTopSubHeaderComponent'
// import BrandBaseLayoutComponent from '../../components/Layout/Brand/BrandBaseLayoutComponent'
// import CreditDetailsComponent from '../../components/Brand/Credit/CreditDetailsComponent';
import { useGlobalState } from '../../store/state';
import BrandChatsListComponent from '../../components/Brand/Chats/BrandChatsListComponent';
import BrandChatBoxComponent from '../../components/Brand/Chats/BrandChatBoxComponent';
import InfluencerBaseLayoutComponent from '../../components/Layout/Influencer/InfluencerBaseLayoutComponent';
import InfluencerTopSubHeaderComponent from '../../components/Influencers/Common/InfluencerTopSubHeaderComponent';
import InfluencerChatsListComponent from '../../components/Influencers/Chats/InfluencerChatsListComponent';
import InfluencerChatBoxComponent from '../../components/Influencers/Chats/InfluencerChatBoxComponent';
// import ChatBox from 'react-custom-chat'

// import 'react-chat-widget/lib/styles.css';

export const InfluencerChatsPage = () => {
  const [user] = useGlobalState('user');
  const [activeChat, setActiveChat] = useState(null);
  const activeChatSetting = (_obj) =>{
    console.log('active chat Ob', _obj);
    setActiveChat(_obj);
  };
  // const history = useHistory();
  // const [company] = useGlobalState("company");
  // const [togg,setTogg] = useState(null)
  // useEffect(() => {
  //     console.log(company.selected)
  //     if(company.selected){
  //         history.push('/brand/'+company.selected.id)
  //     }
  // }, [company.selected])
  // const getCustomLauncher = () =>{
  //     // console.log("ss",togg)
  //     // setTogg(true)
  //     // getCustomLauncher()
  // }
  // const getCustomLauncher = (handleToggle) => <button onClick={handleToggle}>This is my launcher component!</button>

  const [messageList, setMessageList] = useState([
    { text: 'hello', person: 'primary' },
  ]);

  const handleSendMessage = (newMessage) => {
    setMessageList([
      ...messageList,
      { text: newMessage, person: 'primary' },
    ]);
  };
  return (
    <InfluencerBaseLayoutComponent>
      <InfluencerTopSubHeaderComponent className="p-3 sticky">
                Chat Details of <strong>{user.firstname + ' '+ user.lastname}</strong>
        {/* <p className="m-0">Welcome to your wallet</p> */}
      </InfluencerTopSubHeaderComponent>
      <div className="chat_holder p-3">
        <Row gutter={16}
          className="chat_holder_row">
          <Col span={10}>
            {/* <BrandChatsListComponent getActiveChat={activeChatSetting}/> */}
            <InfluencerChatsListComponent getActiveChat={activeChatSetting}/>

          </Col>
          <Col span={14}>
            {/* <BrandChatBoxComponent activeChat={activeChat}/> */}
            <InfluencerChatBoxComponent activeChat={activeChat}/>
          </Col>
        </Row>
      </div>
    </InfluencerBaseLayoutComponent>
  );
};
